/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Provider } from './Provider';
import {
    ProviderFromJSON,
    ProviderFromJSONTyped,
    ProviderToJSON,
    ProviderToJSONTyped,
} from './Provider';

/**
 * Operator serializer, with stats inside.
 * @export
 * @interface OperatorStats
 */
export interface OperatorStats {
    /**
     * 
     * @type {string}
     * @memberof OperatorStats
     */
    operator: string;
    /**
     * 
     * @type {Array<Provider>}
     * @memberof OperatorStats
     */
    stats: Array<Provider>;
}

/**
 * Check if a given object implements the OperatorStats interface.
 */
export function instanceOfOperatorStats(value: object): value is OperatorStats {
    if (!('operator' in value) || value['operator'] === undefined) return false;
    if (!('stats' in value) || value['stats'] === undefined) return false;
    return true;
}

export function OperatorStatsFromJSON(json: any): OperatorStats {
    return OperatorStatsFromJSONTyped(json, false);
}

export function OperatorStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperatorStats {
    if (json == null) {
        return json;
    }
    return {
        
        'operator': json['operator'],
        'stats': ((json['stats'] as Array<any>).map(ProviderFromJSON)),
    };
}

export function OperatorStatsToJSON(json: any): OperatorStats {
    return OperatorStatsToJSONTyped(json, false);
}

export function OperatorStatsToJSONTyped(value?: OperatorStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operator': value['operator'],
        'stats': ((value['stats'] as Array<any>).map(ProviderToJSON)),
    };
}

